import {makeKey} from '../../../../utils/reducerOperations';
export function facetGroupChange(state, payload) {
    return makeKey(
        'defaultFacetGroup',
        state.defaultFacetGroup === payload ? '_' : payload
    );
}